import ItemBasic from './ItemBasic';
import ItemHorizontalCard from './ItemHorizontalCard';
import ItemVerticalCard from './ItemVerticalCard';
import LeftImageItemHorizontalCard from './LeftImageItemHorizontalCard';
import CatalogItemLightbox from '../../../../../modules/catalog/components/CatalogItemLightbox';
import MenuItemCartModal from '../../../../MenuItemCartModal';
var itemVariantComponentMap = {
  Basic: ItemBasic,
  HorizontalCard: ItemHorizontalCard,
  LeftImageHorizontalCard: LeftImageItemHorizontalCard,
  VerticalCard: ItemVerticalCard
};
var itemModalVariantComponentMap = {
  CatalogItemCartModal: MenuItemCartModal,
  CatalogItemLightbox: CatalogItemLightbox
};
export { itemVariantComponentMap, itemModalVariantComponentMap };